import React from "react";
import privacyTranslations from "../i18n/privacyTranslations";
import getCurrentLang from "../utils/getCurrentLang";

export default function Privacy() {
  const lang = getCurrentLang();
  const t = privacyTranslations[lang] || privacyTranslations["pt"];

  return (
    <div style={{ padding: "2rem", maxWidth: "900px", margin: "0 auto", color: "#3E2723" }}>
      <h1>{t.title}</h1>
      {t.sections.map((section, idx) => (
        <div key={idx}>
          <h2>{section.heading}</h2>
          {section.content.map((text, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: text }} />
          ))}
        </div>
      ))}
    </div>
  );
}
